import requests from '@/utils/requests';

/**
 * 添加评论
 * @param {*} data
 */
export function commentAdd (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/basic/comment/add',
    method: 'post',
    data
  });
}

/**
 * 删除评论
 * @param {*} data
 */
export function commentDelete (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/basic/comment/delete',
    method: 'post',
    data
  });
}

/**
 * 修改评论
 * @param {*} data
 */
export function commentModify (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/basic/comment/modify',
    method: 'post',
    data
  });
}

/**
 * 修改评论
 * @param {*} data
 */
export function commentList (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/basic/comment/list',
    method: 'post',
    data
  });
}

/**
 * 节假日列表
 * @param {*} data
 */
export function vacationList (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/basic/vacations',
    method: 'post',
    data
  });
}

/**
 * 获取全局缓存
 * @param {*} data
 */
export function getGlobalConfig (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/getConfig',
    method: 'post',
    data
  });
}

